import React, { useEffect, useState } from "react";
import { auth, db } from "../firebase";
import { doc, getDoc, collection, query, where, getDocs, updateDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import "../styles/Dashboard.css"; // Import CSS for styling

const Dashboard = () => {
  const navigate = useNavigate();
  const [userData, setUserData] = useState(null);
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProfileAndNotifications = async () => {
      const user = auth.currentUser;
      if (!user) {
        navigate("/login");
        return;
      }

      // Fetch user profile
      const profileRef = doc(db, "users", user.uid);
      const profileSnap = await getDoc(profileRef);
      if (profileSnap.exists()) {
        setUserData(profileSnap.data());
      }

      // Fetch notifications
      const notificationsRef = collection(db, "notifications");
      const q = query(notificationsRef, where("userId", "==", user.uid), where("read", "==", false));
      const querySnapshot = await getDocs(q);

      const fetchedNotifications = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setNotifications(fetchedNotifications);
      setLoading(false);
    };

    fetchProfileAndNotifications();
  }, [navigate]);

  // Function to mark a notification as read
  const markAsRead = async (notificationId) => {
    const notificationRef = doc(db, "notifications", notificationId);
    await updateDoc(notificationRef, { read: true });

    // Update state to remove the read notification
    setNotifications(notifications.filter((n) => n.id !== notificationId));
  };

  const handleLogout = () => {
    auth.signOut();
    navigate("/login");
  };

  if (loading) return <h2>Loading...</h2>;

  return (
    <div className="dashboard-container">
      <h2>Welcome, {auth.currentUser?.email}</h2>
      {userData ? (
        <div className="profile-details">
          <p><strong>Name:</strong> {userData.name}</p>
          <p><strong>Age:</strong> {userData.age}</p>
          <p><strong>Marital Status:</strong> {userData.maritalStatus}</p>
          <p><strong>Employment Status:</strong> {userData.employmentStatus}</p>
          <p><strong>Disability Status:</strong> {userData.disabilityStatus ? userData.disabilityStatus : "Not Provided"}</p>
        </div>
      ) : (
        <p style={{ color: "red" }}>No profile data found. Please <a href="/profile">complete your profile</a>.</p>
      )}
{/* 
      <h3>Notifications ({notifications.length})</h3>
      {notifications.length === 0 ? (
        <p>No new notifications</p>
      ) : (
        <ul className="notifications-list">
          {notifications.map((notification) => (
            <li key={notification.id} onClick={() => markAsRead(notification.id)} className="notification-item">
              {notification.message}
            </li>
          ))}
        </ul>
      )} */}

      <button onClick={handleLogout}>Logout</button>
    </div>
  );
};

export default Dashboard;
